import Axios from "../utils/axiosInterceptor";
import { DASHBOARD_APIS, DASHBOARD_CLAIM_APIS } from "../utils/constants";
export const fetchBusinessSnapshot = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/businessSnapShot`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchDSOData = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/daySalesOutstanding`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchDeductionDetailsData = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeId: number,
  visitType: number,
  type: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/deductionDetails`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeId: schemeId,
          visitType: visitType,
          type: type,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchDeduction = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeId: number,
  visitType: number,
  type: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/deduction`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeId: schemeId,
          visitType: visitType,
          type: type,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchMonthOnMonthClaimStatus = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeId: number,
  visitType: number,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/monthOnMonthClaimStatus`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeId: schemeId,
          visitType: visitType,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchAgingSettledCase = async (
  hospitalId: number,
  schemeId: number,
  visitType: number,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/agingInSettledCase`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          schemeId: schemeId,
          visitType: visitType,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchAgingProcessCase = async (
  hospitalId: number,
  schemeId: number,
  visitType: number,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/agingInProcessCase`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          schemeId: schemeId,
          visitType: visitType,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchSchemeTableData = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeName: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/cghsDataTable`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeName: schemeName,
          download: "No", // true for download, false for view
          schemeId: -1, //Dummy scheme id and visit type
          visitType: -1, //As schemeId and visitType headers are mandatory from BE
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching scheme table data:", error);
    throw error;
  }
};
export const DownloadSchemeData = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeName: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/cghsDataTable`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeName: schemeName,
          download: "Yes", // true for download, false for view
          schemeId: -1, //Dummy scheme id and visit type
          visitType: -1, //As schemeId and visitType headers are mandatory from BE
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching scheme table data:", error);
    throw error;
  }
};

export const fetchCghsStatusTable = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeId: number,
  visitType: number,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/cghsStatusTable`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeId: schemeId,
          visitType: visitType,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CGHS status table:", error);
    throw error;
  }
};

export const fetchSchemes = async (hospitalId: number) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/monthOnMonthsSchemes`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CGHS status table:", error);
    throw error;
  }
};

export const fetchPatientListAgingSettledCase = async (
  hospitalId: number,
  schemeId: number,
  visitType: number,
  month: string,
  intervalKey: string,
  settled: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/agingInProcessAndSettledCaseList`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          schemeId: schemeId,
          visitType: visitType,
          settled: settled === "yes" ? "YES" : "NO",
          month: month,
          intervalKey: intervalKey,
          download: "No",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const downloadPatientListAgingSettledCase = async (
  hospitalId: number,
  schemeId: number,
  visitType: number,
  month: string,
  intervalKey: string,
  settled: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/agingInProcessAndSettledCaseList`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          schemeId: schemeId,
          visitType: visitType,
          settled: settled === "yes" ? "YES" : "NO",
          month: month,
          intervalKey: intervalKey,
          download: "Yes",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business snapshot:", error);
    throw error;
  }
};

export const fetchCghsStatusTableList = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeId: number,
  visitType: number,
  status: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/cghsStatusTableList`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeId: schemeId,
          visitType: visitType,
          status: status,
          download: "No", // true for download, false for view
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CGHS status table:", error);
    throw error;
  }
};

export const downloadCghsStatusTableList = async (
  hospitalId: number,
  startDate: string,
  endDate: string,
  schemeId: number,
  visitType: number,
  status: string,
) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.NEW_DASHBOARD_API}/cghsStatusTableList`,
      {
        headers: {
          accept: "*/*",
          hospitalId: hospitalId,
          startDate: startDate,
          endDate: endDate,
          schemeId: schemeId,
          visitType: visitType,
          status: status,
          download: "Yes",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CGHS status table:", error);
    throw error;
  }
};

export const fetchOperationalDashboard = async ({
  hospitalId,
  schemeId,
  startDate,
  endDate,
  criteria,
  admissionType,
}: {
  hospitalId: number;
  schemeId: number;
  startDate: string;
  endDate: string;
  criteria: string;
  admissionType: string;
}) => {
  try {
    const response = await Axios.post(DASHBOARD_APIS.OPERATIONAL_DASHBOARD, {
      hospitalId,
      schemeId,
      startDate,
      endDate,
      criteria,
      admissionType,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching CGHS status table:", error);
    throw error;
  }
};

export const refreshByHospitalId = async (hospitalId: number) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_APIS.OPERATIONAL_DASHBOARD_REFRESH}/${hospitalId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error refreshing data:", error);
    throw error;
  }
};
export const fetchPatientsOPDashboard = async (params: any) => {
  try {
    const response = await Axios.post(
      DASHBOARD_APIS.OP_DASHBOARD_PATIENT_LIST,
      params,
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching patients:", error);
    throw error;
  }
};

export const fetchDashboardSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MNG_DASHBOARD_SUMMARY}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard summary:", error);
    throw error;
  }
};

export const fetchDashboardBillAuditSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/claim-submission-summary`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard summary:", error);
    throw error;
  }
};

export const fetchDashboardSettlementSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/claim-settlement-summary`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard summary:", error);
    throw error;
  }
};

export const fetchAgeingSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MNG_AGE_GROUP}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard summary:", error);
    throw error;
  }
};

export const fetchRejectionDisallowanceSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MNG_REJECTION_DISALLOWANCE}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching rejection disallowance summary:", error);
    throw error;
  }
};

export const fetchDisallowanceSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/disallowance-summary`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching rejection disallowance summary:", error);
    throw error;
  }
};

export const fetchRejectionSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/rejection-summary`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching rejection disallowance summary:", error);
    throw error;
  }
};

export const fetchBillUploadRecon = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId?: number | number[];
  visitTypes?: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.BILL_UPLOAD_RECON}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bill upload recon:", error);
    throw error;
  }
};

export const downloadExcelOperationalDashboard = async (data: any) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.DASHBOARD_EXCEL}`,
      data,
      {
        responseType: "arraybuffer",
      },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : "Operational_dashboard.xlsx";

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a link element to initiate the download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const fetchInProcessAgeingSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitTypes?: any[];
}) => {
  try {
    // const response = await Axios.post(
    //   `${DASHBOARD_CLAIM_APIS.HSP_MNG_AGE_GROUP}`,
    //   payload
    // );

    // const response = await Axios.get(`${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/agingInProcessCase`, {
    //   headers: {
    //     "Content-Type": "application/json",
    //     hospitalId: payload?.healthCareId,
    //     schemeId: payload?.schemeId,
    //     visitType: payload?.visitTypes
    //   }
    // })

    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/in-progress-aging-summary`,
      {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        healthCareId: payload.healthCareId,
        schemeIds: [payload.schemeId],
        visitTypes: payload.visitTypes,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard summary:", error);
    throw error;
  }
};

export const fetchSettlementAgeingSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitTypes: any;
}) => {
  try {
    // const response = await Axios.post(
    //   `${DASHBOARD_CLAIM_APIS.HSP_MNG_AGE_GROUP}`,
    //   payload
    // );

    // const response = await Axios.get(
    //   `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/agingInSettledCase`,
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //       hospitalId: payload?.healthCareId,
    //       schemeId: payload?.schemeId,
    //       visitType: payload?.visitTypes,
    //     },
    //   },
    // );

    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/agingInSettledCase?fromDate=${payload.fromDate}&toDate=${payload.toDate}&healthCareId=${payload.healthCareId}&schemeIds=${payload.schemeId}&visitTypes=${payload.visitTypes}`,
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard summary:", error);
    throw error;
  }
};

export const fetchSubmissionSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
}) => {
  try {
    const response = await Axios.post(`${DASHBOARD_APIS.SUBMISSION_SUMMARY}`, {
      fromDate: payload.fromDate,
      toDate: payload.toDate,
      healthCareId: payload.healthCareId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching submission summary:", error);
    throw error;
  }
};

export const fetchSettlementSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
}) => {
  try {
    const response = await Axios.post(`${DASHBOARD_APIS.SETTLEMENT_SUMMARY}`, {
      fromDate: payload.fromDate,
      toDate: payload.toDate,
      healthCareId: payload.healthCareId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Settlement summary:", error);
    throw error;
  }
};

export const fetchInternalQueryOpenSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.INTERNAL_QUERY_OPEN_SUMMARY}`,
      {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        healthCareId: payload.healthCareId,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching internal query open summary:", error);
    throw error;
  }
};

export const fetchPayerQueryOpenSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.PAYER_QUERY_OPEN_SUMMARY}`,
      {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        healthCareId: payload.healthCareId,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open summary:", error);
    throw error;
  }
};

export const fetchSubmissionTatSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.SUBMISSION_TAT_SUMMARY}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching submission tat summary:", error);
    throw error;
  }
};

export const fetchPayerQueryTatSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.PAYER_QUERY_TAT_SUMMARY}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query tat summary:", error);
    throw error;
  }
};

export const fetchInternalQueryTatSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.INTERNAL_QUERY_TAT_SUMMARY}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching internal query tat summary:", error);
    throw error;
  }
};

export const fetchInternalQueryOpenAgeingSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.INTERNAL_QUERY_OPEN_AGEING_SUMMARY}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching internal query open ageing summary:", error);
    throw error;
  }
};

export const fetchPayerQueryOpenAgeingSummary = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.PAYER_QUERY_OPEN_AGEING_SUMMARY}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchBusinessData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  page: any;
  size: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/business/cases?page=${payload?.page}&size=${payload?.size}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching business summary:", error);
    throw error;
  }
};

export const fetchSettlementData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  page: any;
  size: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/claim-settlement/cases?page=${payload?.page}&size=${payload?.size}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching settlement summary:", error);
    throw error;
  }
};

export const fetchBillAuditData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  page: any;
  size: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/bill-audit/cases?page=${payload?.page}&size=${payload?.size}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bill audit summary:", error);
    throw error;
  }
};

export const fetchRejectionData = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  page: any;
  size: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/rejection/cases?page=${payload?.page}&size=${payload?.size}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching rejection summary:", error);
    throw error;
  }
};

export const fetchSettlementAgeingData = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeIds: any;
  visitType: any;
  page: any;
  size: any;
  agingBucket: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/aging/cases?page=${payload?.page}&size=${payload?.size}&agingBucket=${payload.agingBucket}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching settlement ageing data summary:", error);
    throw error;
  }
};

export const fetchInProgressAgeingData = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeIds: any;
  visitTypes: any;
  page: any;
  size: any;
  agingBucket: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/in-progress-aging-drilldown?page=${payload.page}&size=${payload.size}&agingBucket=${payload.agingBucket}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching settlement ageing data summary:", error);
    throw error;
  }
};

export const fetchDisallowanceData = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  page: any;
  size: any;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/disallowance/cases?page=${payload?.page}&size=${payload?.size}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching disallowance summary:", error);
    throw error;
  }
};

export const fetchSubmissionSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.SUBMISSION_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchSettlementSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.SETTLEMENT_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchInternalQueryOpenSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.INTERNAL_QUERY_OPEN_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchPayerQueryOpenSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.PAYER_QUERY_OPEN_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchSubmissionTatSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.SUBMISSION_TAT_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchPayerQueryTatSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.PAYER_QUERY_TAT_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query tat summary:", error);
    throw error;
  }
};

export const fetchInternalQueryTatSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.INTERNAL_QUERY_TAT_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching internal query tat summary:", error);
    throw error;
  }
};

export const fetchInternalQueryOpenAgeingSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.INTERNAL_QUERY_OPEN_AGEING_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching internal query open ageing summary:", error);
    throw error;
  }
};

export const fetchPayerQueryOpenAgeingSummaryData = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: number[];
  visitTypes: string[];
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.PAYER_QUERY_OPEN_AGEING_SUMMARY_DATA}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payer query open ageing summary:", error);
    throw error;
  }
};

export const fetchHospitalDeskKpiData = async (payload: {
  healthCareId: number[];
  schemeMetaDataId: number;
  visitType: string;
  metricType: string;
  page: number;
  size: number;
  searchTerm?: string;
  unit?: string;
  filterVisitType?: string;
  ageBucket?: string;
  queryStage?: string;
  queryType?: string;
  reconCaseStatus?: string;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.HOSPITAL_DESK_KPI_DATA}`,
      payload,
    );
    const body = response.data;
    return body?.data !== undefined ? body.data : body;
  } catch (error) {
    console.error("Error fetching hospital desk KPI data:", error);
    throw error;
  }
};

export const fetchHospitalDeskKpiCounts = async (payload: {
  healthCareId: number[];
  schemeMetaDataId: number;
  visitType: string;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.HOSPITAL_DESK_KPI_COUNTS}`,
      payload,
    );
    const body = response.data;
    // management_dashboard wraps payloads in { timeStamp, data, error }
    return body?.data !== undefined ? body.data : body;
  } catch (error) {
    console.error("Error fetching hospital desk KPI counts:", error);
    throw error;
  }
};

export const fetchHospitalDeskAgingCounts = async (payload: {
  healthCareId: number[];
  schemeMetaDataId: number;
  visitType: string;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.HOSPITAL_DESK_AGING_COUNTS}`,
      payload,
    );
    const body = response.data;
    return body?.data !== undefined ? body.data : body;
  } catch (error) {
    console.error("Error fetching hospital desk aging counts:", error);
    throw error;
  }
};

export const fetchHospitalDeskEodBodStatus = async (payload: {
  healthCareId: number[];
  schemeMetaDataId: number;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.HOSPITAL_DESK_EOD_BOD_STATUS}`,
      payload,
    );
    const body = response.data;
    return body?.data !== undefined ? body.data : body;
  } catch (error) {
    console.error("Error fetching hospital desk EOD/BOD status:", error);
    throw error;
  }
};

export const downloadHospitalDeskKpiExcel = async (
  payload: {
    healthCareId: number[];
    schemeMetaDataId: number;
    visitType: string;
    metricType: string;
    searchTerm?: string;
    unit?: string;
    filterVisitType?: string;
    ageBucket?: string;
    queryStage?: string;
    queryType?: string;
    reconCaseStatus?: string;
  },
  stageName: string,
) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.HOSPITAL_DESK_KPI_EXPORT}`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${stageName || "hospital-desk"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Error downloading hospital desk KPI excel:", error);
    throw error;
  }
};

export const updateHospitalDeskReconCaseOption = async (payload: {
  id: number;
  serving?: boolean;
  cancelled?: boolean;
}) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.HOSPITAL_DESK_UPDATE_SERVING_CANCELLED}`,
      payload,
    );
    const body = response.data;
    return body?.data !== undefined ? body.data : body;
  } catch (error) {
    console.error("Error updating G7 recon case option:", error);
    throw error;
  }
};

export const downloadBusinessExcel = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitType: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/business/cases/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeId: payload.schemeId,
          visitType: payload.visitType,
        },
        responseType: "arraybuffer",
      },
    );

    // const contentDisposition = response.headers["content-disposition"];
    // const filename = contentDisposition
    //   ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
    //   : "business.xlsx";

     const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const downloadBillAuditExcel = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitType: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/bill-audit/cases/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeId: payload.schemeId,
          visitType: payload.visitType,
        },
        responseType: "arraybuffer",
      },
    );

    const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};


export const downloadClaimSettlementExcel = async (payload: {
  fromDate: string;
  toDate: string;
  healthCareId: number;
  schemeId: any;
  visitType: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/claim-settlement/cases/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeId: payload.schemeId,
          visitType: payload.visitType,
        },
        responseType: "arraybuffer",
      },
    );

    const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const downloadDisallowanceCasesExcel = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeId: any;
  visitType: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/disallowance/cases/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeId: payload.schemeId,
          visitType: payload.visitType,
        },
        responseType: "arraybuffer",
      },
    );

    const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const downloadRejectionCasesExcel = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeId: any;
  visitType: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/rejection/cases/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeId: payload.schemeId,
          visitType: payload.visitType,
        },
        responseType: "arraybuffer",
      },
    );

    const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const downloadAgingCasesExcel = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  ageingBucket: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/aging/cases/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeIds: payload.schemeId,
          visitType: payload.visitType,
          agingBucket: payload.ageingBucket,
        },
        responseType: "arraybuffer",
      },
    );

    const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const downloadInProcessAgingExcel = async (payload: {
  fromDate: any;
  toDate: any;
  healthCareId: number;
  schemeId: any;
  visitType: any;
  ageingBucket: any;
}, stageName: string) => {
  try {
    const response = await Axios.get(
      `${DASHBOARD_CLAIM_APIS.HSP_MANAGEMENT_DASHBOARD}/in-progress-aging/export`,
      {
        headers: {
          accept: "*/*",
          healthCareId: payload.healthCareId,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          schemeIds: payload.schemeId,
          visitTypes: payload.visitType,
          agingBucket: payload.ageingBucket,
        },
        responseType: "arraybuffer",
      },
    );

    const filename = `${stageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const downloadOperationalDashboadExcel = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${DASHBOARD_APIS.DASHBOARD_OPERATIONAL_EXPORT_EXCEL}`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};
